import React from 'react'


const ArrowRight = (props) =>
    <svg
        {...props}
        viewBox="0 0 17.906 31.91"
        xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid">
        <path d="M.995 31.924a.997.997 0 0 1-.68-1.724l15.141-14.226L.315 1.748A.997.997 0 0 1 1.676.294L17.59 15.247a.996.996 0 0 1 0 1.455L1.676 31.654a.994.994 0 0 1-.681.27z" fillRule="evenodd"/>
    </svg>

export default ArrowRight


// WEBPACK FOOTER //
// ./src/components/_common/_icons/ArrowRight.js